module.exports = __webpack_public_path__ + "img/rectangle-vertical-history.410f38ab.svg";